<template>
  <MainHeader v-show="!fullScreen" :parent="parent"></MainHeader>
  <ScrollNoitce v-if="scrollNoticeShow" :content="rollNotice" :speed="20" @closeScrollNotice="closeScrollNotice"></ScrollNoitce>
  <MainCrumb v-show="!fullScreen" v-if="showCrumb" :crumbs="crumbs" :type="crumbType"></MainCrumb>
  <div class="bg-gray app-content flex flex-column">
    <router-view class="flex_1 mt20 mb20" :class="{ 'content-wrap': !fullScreen }" />
  </div>
  <SideBar v-show="!fullScreen && userStore.userInfo.source === 0 && !userStore.userInfo.ico" />
  <NoticeDialog :noticeInfos="popNoticeInfos"></NoticeDialog>
</template>
<script setup lang="ts">
import MainHeader from "../common/MainHeader.vue";
import MainCrumb from "../common/MainCrumb.vue";
import ScrollNoitce from "../common/ScrollNoitce.vue";
import SideBar from "../common/SideBar.vue";
import NoticeDialog from "@/components/util/NoticeDialog.vue";
import { RouteLocationMatched, useRoute } from "vue-router";
import { computed, ComputedRef, onMounted, ref } from "vue";
import { useUserStore } from "@/store";
import { useGlobalStore } from "@/store";
import { request } from "@/services";
type CrumbType = 'route' | 'routeWithTask' | 'taskOnly';
const userStore = useUserStore();
const GlobalStore = useGlobalStore();
const route = useRoute();
const fullScreen: ComputedRef<boolean> = computed(() => {
  return GlobalStore.fullScreen && (route.meta.allowFull as boolean);
});
const parent: ComputedRef<string> = computed(() => {
  return route.meta && route.meta.parent ? (route.meta.parent as string) : "";
});
const showCrumb: ComputedRef<boolean> = computed(() => {
  return route.meta && route.meta.crumb ? (route.meta.crumb as boolean) : false;
});
const crumbs: ComputedRef<RouteLocationMatched[]> = computed(() => {
  return route.matched;
});
const crumbType: ComputedRef<CrumbType> = computed(() => {
  return route.meta && route.meta.crumbType ? (route.meta.crumbType as CrumbType) : "route";
});
const popNoticeInfos = ref<string[]>([]);
const rollNotice = ref("");
const scrollNoticeShow = ref(false);
// 关闭滚动公告
const closeScrollNotice = () => {
  scrollNoticeShow.value = false;
  GlobalStore.ScrollNoitceShow = false;
};
onMounted(() => {
  // 获取公告
  request.get("/common/get-notice").then((res) => {
    popNoticeInfos.value = res.data.popUpNotice;
    let now = new Date();
    let noticeTime = new Date(res.data.abortTime);
    if (now < noticeTime && GlobalStore.ScrollNoitceShow) {
      scrollNoticeShow.value = true;
      rollNotice.value = res.data.rollNotice;
    }
  });
});
</script>
